/**
 * Schedule trigger configuration type and validation
 */

export type ScheduleTriggerConfigType = {
  cronExpression: string;
  timezone?: string;
};

export const defaultScheduleTriggerConfig: ScheduleTriggerConfigType = {
  cronExpression: '',
  timezone: 'UTC',
};

export const validateScheduleTriggerConfig = (
  config: ScheduleTriggerConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.cronExpression || config.cronExpression.trim() === '') {
    errors.cronExpression = 'Cron expression is required';
  } else {
    // Basic cron validation: should have 5 fields
    const parts = config.cronExpression.trim().split(/\s+/);
    if (parts.length !== 5) {
      errors.cronExpression = 'Cron expression must have 5 fields';
    }
  }

  return errors;
};

// Cron presets for common schedules
export const CRON_PRESETS = [
  { id: 'custom', name: 'Custom', cron: '' },
  { id: 'every-minute', name: 'Every minute', cron: '* * * * *' },
  { id: 'every-5-minutes', name: 'Every 5 minutes', cron: '*/5 * * * *' },
  { id: 'every-15-minutes', name: 'Every 15 minutes', cron: '*/15 * * * *' },
  { id: 'every-30-minutes', name: 'Every 30 minutes', cron: '*/30 * * * *' },
  { id: 'hourly', name: 'Every hour', cron: '0 * * * *' },
  { id: 'daily', name: 'Daily at midnight', cron: '0 0 * * *' },
  { id: 'daily-9am', name: 'Daily at 9 AM', cron: '0 9 * * *' },
  { id: 'weekdays', name: 'Weekdays at 9 AM', cron: '0 9 * * 1-5' },
  { id: 'weekly', name: 'Weekly on Monday', cron: '0 0 * * 1' },
  { id: 'monthly', name: 'Monthly on 1st', cron: '0 0 1 * *' },
] as const;

/**
 * Get preview text for the node display
 */
export const getScheduleTriggerPreviewText = (
  config: ScheduleTriggerConfigType,
): string => {
  if (config.cronExpression) {
    const preset = CRON_PRESETS.find((p) => p.cron === config.cronExpression);
    return preset ? preset.name : `Cron: ${config.cronExpression}`;
  }
  return 'Configure schedule';
};
